import React from "react";
import Filter from "./Filter";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import CardsSection from "./CardsSection";
import EarningList from "./EarningList";
import EarningListCommission from "./EarningListCommission";

const MyEarningCommission = ({
  details,
  isLoading,
  isError,
  setDetails,
  getDetails,
  dateRange,
  handleTimeSpan,
  handleDateRange,
  timeSpanInput,
  handleDateRangeSubmit,
  isShowDateFilter,
  walletDetails,
}) => {
  // console.log(details, "]]]]]]]]]]]]]]]]]]]");
  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-my-earnings-body">
        <Filter
          isLoading={isLoading}
          isError={isError}
          setDetails={setDetails}
          getDetails={getDetails}
          dateRange={dateRange}
          handleTimeSpan={handleTimeSpan}
          handleDateRange={handleDateRange}
          timeSpanInput={timeSpanInput}
          handleDateRangeSubmit={handleDateRangeSubmit}
          isShowDateFilter={isShowDateFilter}
        />
        <CardsSection
          isError={isError}
          isLoading={isLoading}
          details={details}
          walletDetails={walletDetails}
        />
        <EarningListCommission
          isError={isError}
          isLoading={isLoading}
          details={details?.topSalingEvents}
          getDetails={getDetails}
          setDetails={setDetails}
        />
      </div>
    </MainComponentWrapper>
  );
};

export default MyEarningCommission;
